if ( typeof VideoBackgroundElement !== 'function' ) {

  // Check if the browser natively supports HLS playback
  function canPlayHLS() {
    const video = document.createElement('video');
    return video.canPlayType('application/vnd.apple.mpegURL') !== ''
        || video.canPlayType('application/x-mpegURL') !== '';
  }

  // Load video sources, removing HLS sources on browsers that don't support them
  function loadVideoSources(video) {
    if (!canPlayHLS()) {
      video.querySelectorAll('source[type="application/x-mpegURL"]').forEach(el => {
        el.remove();
      });
    }
    video.querySelectorAll('source').forEach(elm => {
      elm.src = elm.dataset.src;
    });
    video.load();
  }

  class VideoBackgroundElement extends HTMLElement {

    constructor(){

      super();

      this._eventSuccess = new Event('success');
      this._eventFail = new Event('fail');
      const video = this.querySelector('video');
      video.addEventListener('error', e=>{
        this.switchFallback();
      })
      video.addEventListener('playing', e=>{
        if ( ! this.classList.contains('loaded') ) {
          this.classList.add('loaded');
          this.dispatchEvent(this._eventSuccess);
        }
      })

      // Retry autoplay when the browser has enough data but the video is paused.
      // Chrome can interrupt autoplay when stalled fires during initial buffering.
      video.addEventListener('canplay', e=>{
        if ( video.paused && video.muted ) {
          video.play().catch(() => {});
        }
      })

      // Only fall back to image after a generous timeout, not on stalled event.
      // The stalled event fires too early on Chrome during normal buffering,
      // which prevents the video from ever becoming visible (opacity stays 0).
      video.addEventListener('stalled', e=>{
        if ( ! this.classList.contains('loaded') ) {
          clearTimeout(this._stalledTimer);
          this._stalledTimer = setTimeout(() => {
            if ( ! this.classList.contains('loaded') ) {
              this.switchFallback();
            }
          }, 5000);
        }
      })

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        if ( ( entries[0].target.querySelector('video-background-element') && ! entries[0].target.querySelector('video-background-element').classList.contains('loaded') ) || ( entries[0].tagName == 'video-background-element') && ! entries[0].target.classList.contains('loaded') ) {
          loadVideoSources(video);
        }
        observer.unobserve(this);
      }

      if ( this.getBoundingClientRect().y < window.innerHeight || this.parentNode.getBoundingClientRect().y < window.innerHeight ) {
        loadVideoSources(video);
      } else {
        new IntersectionObserver(handleIntersection.bind(this), {rootMargin: `0px 0px 400px 0px`}).observe(this);
        new IntersectionObserver(handleIntersection.bind(this), {rootMargin: `0px 0px 400px 0px`}).observe(this.parentElement);
      }

    }

    switchFallback(){
      const fallback = this.parentElement.querySelector(`[data-video-background-fallback][data-id="${this.dataset.id}"]`);
      if ( fallback ) {
        fallback.append(fallback.querySelector('template').content.cloneNode(true));
        fallback.querySelector('img').setAttribute('srcset', fallback.querySelector('img').getAttribute('srcset'));
      }
      this.dispatchEvent(this._eventFail);
    }

  }

  if ( typeof customElements.get('video-background-element') == 'undefined' ) {
    customElements.define('video-background-element', VideoBackgroundElement);
  }

}

document.addEventListener('shopify:section:load', e=>{
  if ( e.target.classList.contains('mount-video-background') ) {
    setTimeout(()=>{
      e.target.querySelectorAll('video-background-element').forEach(elm=>{
        loadVideoSources(elm.querySelector('video'));
      });
    }, 500);
  }
});
